import React, { useEffect, useRef, useState } from 'react';
import './integration.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import {
  getJsonFromStorage,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { loadChecksById, loadChecksList } from '../actions';
import { getSystemData } from '../../System/reducer';
import { getIntegrationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { dateTimeFormatter } from '../../../utils/formatters';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { errorNotification } from '../../Notifications/notificationDecorator';
import ChecksView from './ChecksView';
import { INTEGRATION_MODULE } from '../../../configs/moduleNames';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import getDefaultSort from '../../../utils/getDefaultSort';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function ChecksErrorPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const store = useStore();
  const { updatePeriod } = useSelector(getSystemData);
  const {
    checksListMeta,
    loadingChecksList,
    checksList,
    loadingCurrentChecks,
    currentChecks,
  } = useSelector(getIntegrationData);
  const [isShow, setIsShow] = useState(false);

  const { formatMessage } = useIntl();
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[INTEGRATION_MODULE].checksListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: {
        with_error: 1,
        ...getValues(),
      },
      sort,
    };
    const p1 = dispatch(loadChecksList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const defaultFilterValues = { search: '', created_at: '', statuses: [4] };
  const {
    watch, getValues, control, setValue,
  } = useForm({ defaultValues: getJsonFromStorage('check-error-filter', defaultFilterValues) });

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };

  const handleShow = item => event => {
    if (!item) {
      return;
    }
    dispatch(loadChecksById(item.id))
      .then(() => {
        setIsShow(true);
      })
      .catch(response => errorNotification('Загрузка записи', getResponseError(response)));
    return false;
  };

  const handleClose = () => {
    setIsShow(false);
  };

  const columns = [
    {
      dataField: 'type',
      text: 'Запрашиваемая информация',
      formatter: e => e && e.name,
    },
    {
      dataField: 'id',
      text: 'Причина ошибки',
      formatter: e => 'Ошибка СМЭВ',
    },
    {
      dataField: 'id',
      text: 'Идентификатор запроса',
    },
    {
      dataField: 'created_at',
      text: 'Дата и время запроса',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'message',
      text: 'Описание ошибки',
    },
  ];

  const renderContextMenu = item => (
    <div className="more-wrapper">
      <Button variant="link" className="w-100 more-button" onClick={handleShow(item)}>
        Просмотр
      </Button>
    </div>
  );

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={renderContextMenu(item)}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );
  useEffect(() => {
    const subscription = watch(values => {
      loadData({ page: 1 });
      localStorage.setItem('check-error-filter', JSON.stringify(values));
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const [sort, setSort] = useState(getDefaultSort(columns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);
  return (
    <div className="page application-page">
      <TimerLoader global loading={loadingChecksList || loadingCurrentChecks} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.integration.error.list' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
          />
          <FieldDTO
            control={control}
            component={RangeDatePicker}
            dtoObject={{
              name: 'created_at',
              type: String,
              labelKey: 'created_at',
            }}
            usePortal
            placeholder="Дата"
            changeFormat="YYYY-MM-DD"
            inputProps={{
              value: [getValues('created_at_from'), getValues('created_at_to')],
              onChange: e => {
                const v = e.target.value;
                setValue('created_at_from', v[0]);
                setValue('created_at_to', v[1]);
              },
            }}
            className="no-border"
          />
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                data={checksList}
                columns={columns}
                rowClassFormatter={rowClassFormatter}
                name="check-error-list"
                settingsFormatter={moreFormatter}
                renderContextMenu={renderContextMenu}
                onDoubleClickByRow={(item, event) => handleShow(item)(event)}
                changeSort={changeSort}
                sort={sort}
              />
            </div>
          </div>
          <Pagination meta={checksListMeta} list={checksList} handleChangeMeta={loadData} />
        </div>
      </div>
      {isShow ? <ChecksView key={currentChecks && currentChecks.id} current={currentChecks} close={handleClose} /> : null}

    </div>
  );
}
